'use strict';
const mmWidgets = require('./mm-widgets'),
	_ = require('underscore');
require('./gold-plan-option-widget');
mmWidgets.fn.goldPlanSelectorWidget = function (subscriptionPlanModel) {
	return mmWidgets.each(this, function () {
		const widget = this,
			showPlans = function (plans, selectedPlan) {
				widget.empty();
				_.each(plans, function (plan) {
					mmWidgets('<option></option>').goldPlanOptionWidget(plan).appendTo(widget);
				});
				widget.val(JSON.stringify(selectedPlan));
			};

		subscriptionPlanModel.addEventListener('subscriptionPlansChanged', showPlans);

		subscriptionPlanModel.addEventListener('planSelected', function (plan) {
			widget.val(JSON.stringify(plan));
		});

		widget.on('change', function () {
			const val = widget.val(),
				plan = val && JSON.parse(val);
			if (plan) {
				subscriptionPlanModel.setSelectedPlan(plan);
			}
		});

		showPlans(subscriptionPlanModel.availablePlans(), subscriptionPlanModel.getSelectedPlan());
	});
};
